import { render, staticRenderFns } from "./PlainBtn.vue?vue&type=template&id=45057781"
import script from "./PlainBtn.vue?vue&type=script&lang=js"
export * from "./PlainBtn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports